// app/javascript/controllers/toggle_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "replyForm"]

    toggle() {
        this.contentTargets.forEach(target => {
            target.classList.toggle("hidden")
        })
    }

    toggleReply() {
        if (this.hasReplyFormTarget) {
            this.replyFormTarget.classList.toggle("hidden")
            // Focus the input when showing
            if (!this.replyFormTarget.classList.contains("hidden")) {
                const input = this.replyFormTarget.querySelector("input[type='text']")
                if (input) input.focus()
            }
        }
    }

    toggleEdit() {
        const commentId = this.element.id?.replace("comment_", "")
        if (!commentId) return

        const bodyEl = document.getElementById(`comment_body_${commentId}`)
        const editEl = document.getElementById(`edit_comment_${commentId}`)

        if (bodyEl && editEl) {
            bodyEl.classList.toggle("hidden")
            editEl.classList.toggle("hidden")
            // Focus input when showing edit
            if (!editEl.classList.contains("hidden")) {
                const input = editEl.querySelector("input[type='text']")
                if (input) input.focus()
            }
        }
    }
}
